import InnerLayout from "../../../layouts/inner-layout";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useLayoutEffect, useRef, useState } from "react";
import TabsComponent from "../../../helper-components/tabs-component";
import VendorItemMapping from "./vendor-item-mapping";
import BussinessCatalouge from "./bc-main-page";
import ViewVendorCatalouge from "./view-vendor-catalouge";
const BussinessCatalougeCreate = () => {
  const navigate = useNavigate();
  const rootRef = useRef(null);
  const [availHeight, setAvailHeight] = useState(null);
  const { type, id } = useParams();
  useLayoutEffect(() => {
    const calc = () => {
      const el = rootRef.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      const h = Math.max(0, window.innerHeight - top);
      setAvailHeight(h);
    };

    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, []);

  const [currentTab, setCurrentTab] = useState(type==="new"?"Vendor-Item Mapping":"Item-Vendor Mapping");
  return (
    <InnerLayout title="Settings" module="bussiness-catalouge-create" list={true}>
      {/* ref is here so we measure from inside InnerLayout */}
      <div ref={rootRef} className="w-full">
        <div
          style={{ height: availHeight ?? "100dvh" }}
          className="flex flex-col min-h-0 overflow-hidden"
        >
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 my-2 mx-6 text-sml shrink-0">
            <button className="flex items-center gap-2" onClick={() => navigate("/settings/bussiness-catalouge")}>
              <ChevronLeftIcon className="h-5 w-5 inline-block" />
              Data Setup Settings /
            </button>
            <span className="cursor-pointer">{" " + "Bussiness Catalouge"}</span>
          </div>
          <TabsComponent
              handleClickfn={(item) => {
                  setCurrentTab(item);
              }}
              itemTabs={itemTabs}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
          />
          {currentTab === "Vendor-Item Mapping" && (
              <VendorItemMapping />
          )}
          {currentTab === "Item-Vendor Mapping" && (
              <ViewVendorCatalouge />
          )}
        </div>
      </div>
    </InnerLayout>
  );
};

export default BussinessCatalougeCreate;

const itemTabs = [
    "Vendor-Item Mapping",
    "Item-Vendor Mapping",
]
